import {ClientsState, VehiclesState} from "types/store";

export function parseClients(list?: VehiclesState["clients"]) {
  if (list) {
    return list.map((client) => ({
      label: client.name,
      value: client.id,
    }));
  }

  return [];
}

export function parseOrganizationClients(search: ClientsState["search"],list?: ClientsState["organizations"]) {
  if (list) {
    const data = list.map((client) => ({
      name: client.name,
      //organization_name: client.ownerOrgName,
      address: client.address?.streetAddress1,
      city: client.address?.city,
      state: client.address?.state,
      country: client.address?.country,
      raw: client,
    }));
         return  data.filter((client) => {
      return Object.values({
        name: client.name,
      })
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
  }

  return [];
}

export function parseDropdownOrganization(list?: { name: string; id: string }[]) {
  if (list) {
    return list.map((client) => ({
      label: client.name,
      value: client.id,
    }));
  }

  return [];
}